export const Hero = () => (
  <section id="hero" className="relative min-h-[88vh] flex items-end justify-start overflow-hidden bg-[#0D2121]" data-testid="hero-section">
    <div className="absolute inset-0 z-0 overflow-hidden">
      <img
        src="https://images.pexels.com/photos/31077121/pexels-photo-31077121.jpeg"
        alt="Warm contemporary Indian living room with cane accents and courtyard light"
        className="w-full h-full object-cover animate-subtle-zoom"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D2121] via-[#0D2121]/60 to-transparent"></div>
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 py-20 w-full">
      <div className="max-w-3xl space-y-6">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#FAF6F0]/10 border border-[#FAF6F0]/20 text-[#EADBC8] text-xs uppercase tracking-widest">
          Interior Architecture &amp; Custom Furnishing
        </div>
        <h1 className="font-display text-4xl sm:text-6xl md:text-7xl font-light text-[#FAF6F0] leading-[1.08] tracking-tight" data-testid="hero-headline">
          Homes Rooted in Warmth
        </h1>
        <p className="text-base sm:text-lg text-[#EADBC8] font-normal leading-relaxed max-w-2xl" data-testid="hero-subtext">
          Warm, modern aesthetics rooted in Indian living. We handle everything from foundational layout and on-site execution to custom furniture and final handover.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
          <a
            href="#contact"
            data-testid="hero-book-consultation-btn"
            className="inline-flex items-center justify-center px-7 py-4 text-sm font-semibold tracking-wide text-[#0D2121] bg-[#E2A435] hover:bg-[#c88c2a] transition-colors text-center"
          >
            Book Consultation
          </a>
          <a
            href="#gallery"
            data-testid="hero-explore-gallery-btn"
            className="inline-flex items-center justify-center px-7 py-4 text-sm font-semibold tracking-wide text-[#FAF6F0] border border-[#FAF6F0]/40 hover:bg-[#FAF6F0]/10 transition-colors text-center"
          >
            Explore Curated Spaces
          </a>
        </div>
      </div>
    </div>
  </section>
);
